import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  isShopifyTarget = signal<boolean>(false);

  isShopify = signal<boolean>(false);
  learningMode = signal<boolean>(false);
  autoActivate = signal<boolean>(false);
  behamicsDeactivated = signal<boolean>(false);

  targetUrl = signal<string>('');

  /** The selected target's `ab_testing_tool` flag: the new nudge view instead of the old one. */
  abTestingView = signal<boolean>(false);
}
